import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { EmailComponent, EqValidator, PasswordComponent, TextInputComponent, DatePickerComponent, CheckboxComponent, PhoneNumberComponent, AppName } from '@equine-ui-nx/ui';
import { CommunicationType, ReceiverDet, SignUpRequest } from '../../interfaces/signUp.interface';
import { CustomValidator } from './custom.validator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { CommunicationPrefComponentArenaEQ } from '../communicationPrefArenaEQ/communicationPrefArenaEQ.component';
@Component({
  selector: 'signup-form',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule, 
    TextInputComponent, 
    EmailComponent, 
    PasswordComponent, 
    DatePickerComponent, 
    CheckboxComponent, 
    PhoneNumberComponent, 
    MatTooltipModule,
    MatIconModule,
    CommunicationPrefComponentArenaEQ
  ],
  templateUrl: './signup-form.component.html',
  styleUrl: './signup-form.component.scss',
})
export class SignupFormComponent implements OnChanges, OnInit {

  @Input('isEmailExists') isEmailExists: boolean = false;
  @Input('isMobileExists') isMobileExists: boolean = false;
  @Input('loading') loading: boolean = false;
  @Output('signUp') signUpEvent = new EventEmitter<SignUpRequest>();
  @Output('navigateToPage') navigateToPageEvent = new EventEmitter<string[]>();
  @Output('checkEmailOMobileExists') checkEmailOMobileExists = new EventEmitter<ReceiverDet>();
  @Input('formData') formData: any;
  @Input('appName') appName!: string;

  signUpForm = new FormGroup({});
  requiredValidator = {
    validators: Validators.required,
    message: 'This field is required',
    error: 'required',
  };
  activeCommunicationTypes: Array<string> = []
  firstNameValidators: EqValidator[] = [this.requiredValidator];
  lastNameValidators: EqValidator[] = [this.requiredValidator];
  emailValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: Validators.email,
      message: 'Invalid Email',
      error: 'email'
    },
    {
      validators: Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
      message: 'Invalid Email',
      error: 'pattern',
    },
    {
      validators: CustomValidator.customValidate(),
      message: 'EmailAlreadyExists',
      error: 'alreadyExists'
    }
  ];
  confirmEmailValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: CustomValidator.customValidate(),
      message: 'Email Address does not match',
      error: 'notMatched',
    }
  ];
  passwordValidators: EqValidator[] = [
    {
      validators: Validators.required,
      message: 'This field is required',
      error: 'required'
    },
    {
      validators: Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{10,50}$/),
      message: 'password must be 10 characters including uppercase, lowercase, number and special characters',
      error: 'pattern'
    }
  ];
  confirmPasswordValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: CustomValidator.customValidate(),
      message: 'Password does not match',
      error: 'notMatched'
    }
  ];
  phoneNumberValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: Validators.pattern(/^\d{10}$/),
      message: 'Please enter the phone number in the correct format (e.g., 1234567890)',
      error: 'pattern'
    },
    {
      validators: CustomValidator.customValidate(),
      message: 'Oops, that phone number is already in use! Enter a different phone number.',
      error: 'alreadyExists'
    }
  ];
  dobValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: CustomValidator.customValidate(),
      message: "You should be 18 year's old or above to create an IEA account",
      error: 'gt18Years'
    }
  ];
  agreeValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: CustomValidator.customValidate(),
      message: "Check our terms and conditions",
      error: 'accept'
    }
  ];

  showPassword: boolean = false;
  showConfrimPassword: boolean = false;
  communicationType = CommunicationType;
  lastExistingCheckedEmail: string = '';
  lastExistingCheckedMobile: string = '';
  logoUrl = ``
  backgroundImageId = ``

  constructor(
    @Inject('environment') private environment: any,
  ){}
  ngOnInit(): void {
    if(this.appName == "arenaEqApp"){
      this.backgroundImageId = 'intro-arena'
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.logoUrl = `../../../assets/images/access-logo-full.png`
      this.backgroundImageId = 'intro-iea'
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['isEmailExists']?.currentValue) {
      this.signUpForm.get('email')?.setErrors({'alreadyExists': true});
    } else if(changes['isEmailExists']?.currentValue === false){
      this.signUpForm.get('email')?.setErrors(null);
    }

    if(changes['isMobileExists']?.currentValue) {
      this.signUpForm.get('phoneNumber')?.setErrors({'alreadyExists': true});
    } else if(changes['isMobileExists']?.currentValue === false){
      this.signUpForm.get('phoneNumber')?.setErrors(null);
    }

    if(changes['formData']?.currentValue) {
      this.signUpForm.patchValue({
        firstName: this.formData?.firstName,
        lastName: this.formData?.lastName,
        email: this.formData?.email,
        confirmEmail: this.formData?.email
      });
    }
  }

  onFieldChange(fieldName: string, value: any) {
    switch (fieldName) {
      case 'email':
        if(this.signUpForm.get('confirmEmail')?.value) {
          this.onFieldChange('confirmEmail', null);
        }
        break;

      case 'confirmEmail':
        if(this.signUpForm.get('email')?.value == this.signUpForm.get('confirmEmail')?.value) {
          this.signUpForm.get('confirmEmail')?.setErrors(null);
        } else {
          this.signUpForm.get('confirmEmail')?.setErrors({'notMatched': true});
        }
        break;

      case 'password':
        if(this.signUpForm.get('confirmPassword')?.value) {
          this.onFieldChange('confirmPassword', null);
        }
        break;

      case 'confirmPassword':
        if(this.signUpForm.get('password')?.value == this.signUpForm.get('confirmPassword')?.value) {
          this.signUpForm.get('confirmPassword')?.setErrors(null);
        } else {
          this.signUpForm.get('confirmPassword')?.setErrors({'notMatched': true});
        }
        break;

      case 'dob':
        if(value) {
          const currentDate = new Date(new Date().setHours(0,0,0,0));
          const eighteenYearBackDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 18));
          if(new Date(value) <= eighteenYearBackDate) {
            this.signUpForm.get('dob')?.setErrors(null);
          } else {
            this.signUpForm.get('dob')?.setErrors({'gt18Years': true});
          }
        }
        break;

      case 'isAccepted':
        if(value) {
          this.signUpForm.get('isAccepted')?.setErrors(null);
        } else {
          this.signUpForm.get('isAccepted')?.setErrors({'accept': true});
        }
      break;

      default:
        break;
    }
  }

  emailValueChanged(changedValue: string) {
    if(
      !this.signUpForm.get('email')?.errors?.['required'] &&
      !this.signUpForm.get('email')?.errors?.['email'] &&
      !this.signUpForm.get('email')?.errors?.['pattern'] &&
      this.lastExistingCheckedEmail !== changedValue
    ) {
      this.lastExistingCheckedEmail = changedValue;
      this.checkEmailOMobileExists.emit({communicationType: CommunicationType.EMAIL, receiver: changedValue});
    }
  }

  phoneNumberValueChanged(changedValue: string) {
    if(
      !this.signUpForm.get('phoneNumber')?.errors?.['required'] &&
      !this.signUpForm.get('phoneNumber')?.errors?.['pattern'] &&
      this.lastExistingCheckedMobile !== changedValue
    ) {
      this.lastExistingCheckedMobile = changedValue;
      this.checkEmailOMobileExists.emit({communicationType: CommunicationType.MOBILE, receiver: changedValue.replace(/[^0-9]/g, "")});
    }
  }

  onEmailBlur(value: string) {
    this.emailValueChanged(value);
  }

  onPhoneNumberBlur(value: string) {
    this.phoneNumberValueChanged(value);
  }

  navigateToResetPassword() {
    this.navigateToPageEvent.emit(['account','resetPassword']);
  }

  signUp(e: any) {
    if(this.signUpForm.valid && !this.loading) {
      this.loading = true;
      const phoneNumber: any = this.signUpForm.get('phoneNumber')?.value;
      const dob:any = this.getDateInString(new Date(`${this.signUpForm.get('dob')?.value}`))
      const signupData: SignUpRequest = {
        firstName: this.signUpForm.get('firstName')?.value,
        lastName: this.signUpForm.get('lastName')?.value,
        email: this.signUpForm.get('email')?.value,
        mobile: phoneNumber.replace(/[^0-9]/g, ""),
        password: this.signUpForm.get('password')?.value,
        confirmPassword: this.signUpForm.get('confirmPassword')?.value,
        dob: dob,
        activeCommunicationTypes: this.activeCommunicationTypes
      };

      this.signUpEvent.emit(signupData);
    }else{
      this.signUpForm.markAllAsTouched()
    }
  }

  getDateInString(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate() > 1 ? date.getDate() : 1;
    if(!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    } else {
      return '';
    }
  }

  navigateTologinPage(): void {
    this.navigateToPageEvent.emit(['account','login']);
  }

  goToTermsAndCondition(): void {
    let url = ""
    if(this.appName == AppName.ARENA_EQ){
      // url = "https://iea-public-content.s3.us-east-1.amazonaws.com/files/arenaEQ-terms-of-use.pdf";
      url = `${this.environment.arenaEqAppUrl}/terms-condition`;
    }else{
      url = "https://iea-public-content.s3.amazonaws.com/files/Terms-of-Use-Agreement.pdf";
    }
    window.open(url, "_blank")
  }

  goToPrivacyPolicy(): void {
    let url = ""
    if(this.appName == AppName.ARENA_EQ){
      url = "https://iea-public-content.s3.us-east-1.amazonaws.com/files/arenaEQ-privacy-policy-10-1-2025.pdf";
      url = `${this.environment.arenaEqAppUrl}/privacy-policy`;
    }else{
      url = "https://iea-public-content.s3.amazonaws.com/files/Privacy-Policy.pdf"
    }
    window.open(url, "_blank")
  }
  changeCommunicationPrefHandler(values: any){
    this.activeCommunicationTypes = values.activeCommunicationTypes
  }
}
